import { Box } from '@mui/material';

import OperationCRIInvestorsPosition from './OperationCRIInvestorsPosition';
import OperationPrimaryInvestors from '../../OperationPrimaryInvestors';

type Props = {
  operationName: string;
  hash: string;
  market: string;
};

export default function OperationInvestors({
  operationName,
  hash,
  market,
}: Props) {
  return (
    <Box>
      <OperationCRIInvestorsPosition
        operationName={operationName}
        operationId={hash}
      />
      <OperationPrimaryInvestors
        hash={hash}
        market={market.toUpperCase()}
        operationName={operationName}
      />
    </Box>
  );
}
